// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import caseEvidenceEntity from './entities/case-evidence.json';
import caseEvidenceMenu from '../pages/case-evidence/menu.json';
import caseEvidenceFullForm from '../pages/case-evidence/forms/full.json';
import caseEvidenceContextForm from '../pages/case-evidence/forms/context.json';
import caseEvidenceMiniForm from '../pages/case-evidence/forms/mini.json';
import caseEvidenceLookupForm from '../pages/case-evidence/forms/lookup.json';
import caseEvidenceTableView from '../pages/case-evidence/views/table.json';
import caseEvidenceCardsView from '../pages/case-evidence/views/cards.json';
import caseEvidenceCalendarView from '../pages/case-evidence/views/calendar.json';
import caseEvidenceDashboardView from '../pages/case-evidence/views/dashboard.json';

/** Тип запису «Докази справи» зі сторінками пакета: меню, форми та подання з pages/case-evidence/. */
export const caseEvidenceDefinition: IRecordTypeDefinition = {
  ...caseEvidenceEntity,
  views: assembleViewSet({
      table: caseEvidenceTableView,
      cards: caseEvidenceCardsView,
      calendar: caseEvidenceCalendarView,
      dashboard: caseEvidenceDashboardView,
  }),
  form: caseEvidenceFullForm,
  forms: { full: caseEvidenceFullForm, context: caseEvidenceContextForm, mini: caseEvidenceMiniForm, lookup: caseEvidenceLookupForm },
  menu: caseEvidenceMenu,
} as IRecordTypeDefinition;
